import { render, staticRenderFns } from "./RadiochemRadionuclideInput.vue?vue&type=template&id=d4c44fca&scoped=true"
import script from "./RadiochemRadionuclideInput.vue?vue&type=script&lang=ts"
export * from "./RadiochemRadionuclideInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c44fca",
  null
  
)

export default component.exports